import _get from 'lodash/get';
import _merge from 'lodash/merge';
import config from '@bedrock-rdk/config';
// eslint-disable-next-line import/no-unresolved
import engine from './nielsenMediametrie.engine';

export const engineName = 'nielsenMediametrie';

export const getEngine = () => {
  const { analytics } = config;
  const { taggingPlans } = analytics;
  const initParams = _get(analytics, `initParams.${engineName}`, {});

  return {
    thirdPartyServiceConfig: {
      key: engineName,
      name: engineName,
      bootMethod: () => require('./nielsenMediametrie.boot'),
      engine: () => engine,
      initParams: {
        events: _get(taggingPlans, engineName, {}),
        ..._merge(initParams, { useLayout: true }),
      },
    },
    cleanup: () => {
      engine.release();

      delete window.NOLBUNDLE;

      const scripts = Array.from(document.querySelectorAll('script')).filter(
        script => Boolean(script.src) && (script.src.includes('cdn-gl.nmrodam') || /\/sp-.*\.js/.test(script.src)),
      );

      if (scripts && scripts.length) {
        scripts.forEach(script => script.remove());
      }
    },
  };
};
